var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1127_7316)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5455 12.2727C24.5455 19.0514 19.0508 24.5455 12.2727 24.5455C5.49464 24.5455 0 19.0514 0 12.2727C0 5.49409 5.49464 0 12.2727 0C19.0508 0 24.5455 5.49409 24.5455 12.2727ZM21.8182 12.2727C21.8182 17.5445 17.5445 21.8182 12.2727 21.8182C7.00091 21.8182 2.72727 17.5445 2.72727 12.2727C2.72727 7.00091 7.00091 2.72727 12.2727 2.72727C17.5445 2.72727 21.8182 7.00091 21.8182 12.2727Z",
    fill: "#F89500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6365 17.7267C13.6365 18.4795 13.026 19.0904 12.2728 19.0904C11.5197 19.0904 10.9092 18.4795 10.9092 17.7267V10.9086C10.9092 10.1558 11.5197 9.54492 12.2728 9.54492C13.026 9.54492 13.6365 10.1558 13.6365 10.9086V17.7267Z",
    fill: "#F89500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9092 6.81774C10.9092 6.06501 11.5197 5.4541 12.2728 5.4541C13.026 5.4541 13.6365 6.06501 13.6365 6.81774C13.6365 7.57047 13.026 8.18137 12.2728 8.18137C11.5197 8.18137 10.9092 7.57047 10.9092 6.81774Z",
    fill: "#F89500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5455 12.2727C24.5455 19.0514 19.0508 24.5455 12.2727 24.5455C5.49464 24.5455 0 19.0514 0 12.2727C0 5.49409 5.49464 0 12.2727 0C19.0508 0 24.5455 5.49409 24.5455 12.2727ZM21.8182 12.2727C21.8182 17.5445 17.5445 21.8182 12.2727 21.8182C7.00091 21.8182 2.72727 17.5445 2.72727 12.2727C2.72727 7.00091 7.00091 2.72727 12.2727 2.72727C17.5445 2.72727 21.8182 7.00091 21.8182 12.2727Z",
    fill: "#F89500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6365 17.7267C13.6365 18.4795 13.026 19.0904 12.2728 19.0904C11.5197 19.0904 10.9092 18.4795 10.9092 17.7267V10.9086C10.9092 10.1558 11.5197 9.54492 12.2728 9.54492C13.026 9.54492 13.6365 10.1558 13.6365 10.9086V17.7267Z",
    fill: "#F89500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9092 6.81774C10.9092 6.06501 11.5197 5.4541 12.2728 5.4541C13.026 5.4541 13.6365 6.06501 13.6365 6.81774C13.6365 7.57047 13.026 8.18137 12.2728 8.18137C11.5197 8.18137 10.9092 7.57047 10.9092 6.81774Z",
    fill: "#F89500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1127_7316",
    x: 0,
    y: 0,
    width: 24.8787,
    height: 24.8787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1127_7316"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.91d35eed9c6432af278ec3aa6d12ef64.svg";
export { ForwardRef as ReactComponent };